import BlobAnalysisService from './blob-analysis-service';
import RasterScanService from './raster-scan-service';
import RasterPanel from './raster-panel';
import app from '../../public-api';
import { env } from '../../lib/utility/browser-compatibility';

const canStart = (uScope) => {
  return (
    !env.isIOS &&
        env.supportsCanvas &&
        uScope.toolbarCanAddButton('autoRaster'));
};

app.plugins.register({
  name: 'us:raster-scan:ui',
  extends: 'uScope',
  canStart,
  constructor: RasterPanel
});

app.plugins.register({
  name: 'us:raster-scan:blob-analysis',
  extends: 'viewport',
  canStart,
  constructor: BlobAnalysisService
});

app.plugins.register({
  name: 'us:raster-scan:service',
  extends: 'viewport',
  dependencies: ['us:raster-scan:ui', 'us:raster-scan:blob-analysis', 'us:thumbnail', 'us:heatmap', 'us:user-config'],
  canStart,
  constructor (uScope, viewport, ...deps) {
    // hack alert: using the viewport as a service locator...
    const rss = new RasterScanService(uScope, viewport, ...deps);
    viewport.rasterScan = rss;
  }
});



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/raster-scan/raster-scan-loader.js